module.exports = __webpack_public_path__ + "media/SWV-I_DW_2_Punktebild.53dc9a50.mp3";